import React, { useEffect } from "react"
import BackButton from "../components/controls/BackButton"
import LoanFields from "../components/new-loan/LoanFields"
import LoanSidePane from "../components/new-loan/LoanSidePane"
import withLocale from "./withLocale";
import { Form, FormRenderProps } from "react-final-form"
import { Loan, LoanType } from "../types/loan";
import { localizedLoadPage } from "../utils/navigation"
import { getLocalOrNewLoan, saveLocalLoan } from "../utils/loan"
import { useLocation } from "@reach/router";
import { trackGTM, generateDataLayerEventObject, convertToDataLayerName } from "../utils/trackGTM";
import {
  trackGAEventforPHD,
  generateLoanApplicationFilledEventObject,
  generateLoanApplicationStartedEventObject
} from "../utils/trackGAEventforPHD";

const renderForm = (renderProps: FormRenderProps<Loan>): JSX.Element => {
  const { values: { amount, period, loanType, minRefinanceAmount } } = renderProps;

  return (
    <form id="form_new_loan" onSubmit={renderProps.handleSubmit}>
      <LoanFields amount={amount} period={period} loanType={loanType} minAmount={minRefinanceAmount}/>
    </form>
  )
}

const NewLoan = (): JSX.Element => {
  const queryParameters = useLocation().search;
  const loanType = queryParameters && queryParameters.split("=")[1];
  const initialValues = getLocalOrNewLoan(loanType as LoanType);

  useEffect(() => {
    trackGAEventforPHD(generateLoanApplicationStartedEventObject());
  }, []);

  const submitForm = (loan: Loan): void | FormErrors => {
    if (loan.purpose !== "other") {
      loan.otherPurpose && delete loan.otherPurpose;
    }
    if (loan.purpose === "other" && !loan.otherPurpose) {
      return { otherPurpose: ["can't be blank"] };
    }

    saveLocalLoan(loan);

    trackGTM({
      ...generateDataLayerEventObject('choose_loan'),
      item_name: convertToDataLayerName(loan.purpose),
    });

    trackGAEventforPHD(generateLoanApplicationFilledEventObject(loan));

    localizedLoadPage("borrowers/new")
  }

  return (
    <main className="PageSection PageSection--offset-top-extra u-mt-lg">
      <div className="PageSection-content PageSection-content--flex">
        <div className="flex-col-2 d-n-sm-none">
          <BackButton className="u-min-w-88"/>
        </div>
        <div className="Form flex-auto">
          <Form
            initialValues={initialValues}
            onSubmit={submitForm}
            render={renderForm}
          />
        </div>
        <LoanSidePane/>
      </div>
    </main>
  )
}

export default withLocale(NewLoan);
